import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../api/client';
import type { TagDetail } from '../types';

export default function TagDetailPage() {
  const { name } = useParams<{ name: string }>();
  const [detail, setDetail] = useState<TagDetail | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!name) return;
    api<{ data: TagDetail }>(`/tags/${encodeURIComponent(name)}`)
      .then((r) => setDetail(r.data))
      .catch(() => setError('Tag not found.'));
  }, [name]);

  if (error) return <div className="card"><p className="error">{error}</p></div>;
  if (detail === null) return <div className="card"><p className="muted">Loading…</p></div>;

  return (
    <div className="card">
      <p style={{ marginTop: 0, marginBottom: 12 }}>
        <Link to="/tags">← All tags</Link>
      </p>
      <h2 style={{ marginTop: 0 }}>{detail.tag.name}</h2>
      <p className="muted" style={{ fontSize: 13, marginTop: -4 }}>
        {detail.archives.length} archive{detail.archives.length === 1 ? '' : 's'} tagged.
      </p>
      {detail.archives.length === 0 ? (
        <p className="muted">No archives carry this tag yet.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Domain</th>
              <th>Status</th>
              <th style={{ textAlign: 'right' }}>Pages</th>
              <th>Last crawl</th>
            </tr>
          </thead>
          <tbody>
            {detail.archives.map((a) => (
              <tr key={a.id}>
                <td>
                  <Link to={`/archives/${a.id}`}>{a.domain}{a.path_prefix}</Link>
                </td>
                <td><span className={`status-pill ${a.status}`}>{a.status}</span></td>
                <td style={{ textAlign: 'right' }}>{a.pages_fetched.toLocaleString()}</td>
                <td className="muted" style={{ whiteSpace: 'nowrap' }}>
                  {a.last_crawled_at ? new Date(a.last_crawled_at).toLocaleString() : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
